import React from 'react';
import MyBlogs from './MyBlogs';
import BottomToTop from './BottomToTop';
import "./Blogs.css";

function Blogs() {

  return (
    <>
      <div style={{backgroundColor: "#eaeaea", paddingBottom: "1rem"}}>

      <BottomToTop/>


        <div className="container text-center d-flex justify-content-center align-items-center">
          <div className="container pt-4">
            <h1 style={{fontSize: "3rem", color: "#000000"}}>Blogs</h1>
          </div>
        </div>

        <div className=" container blogsImgContainer d-flex justify-content-center align-items-center">
          <img src="blogsImg.png" alt="blogsImage" className="blogsImg"></img>
        </div>

        <div className="container" style={{ width: "90%" }}>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/The_future_of_Social_Media_Growth-How_fast-growing_startups_can_stay_ahead" title="The Future of Social Media Growth: How Fast-Growing Startups Can Stay Ahead" text="In the digital age, social media growth is the lifeblood of startup success. For fast-growing startups, the ability..." />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/Why_Content_Marketing_is_the_heart_of_Startup_Success" title="Why Content Marketing Is the Heart of Startup Success" text="For startups, the path to success often feels like walking a tightrope. Limited budgets, fierce competition and..."/>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/The_ultimate_checklist_for_building_a_brand_on_social_media" title="The Ultimate Checklist for Building a Brand on Social Media" text="In today’s digital-first world, social media has become the cornerstone for building successful brands. With over..."/>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/Content_Marketing_vs_Traditional_Marketing-Why_startups_should_go_digital" title="Content Marketing vs. Traditional Marketing: Why Startups Should Go Digital" text="In today's fast-paced world, marketing plays a critical role in the success of any business. For startups, choosing..."/>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/How_to_leverage_Social_Media_Analytics_for_Explosive_Growth" title="How to Leverage Social Media Analytics for Explosive Growth" text="Social media is more than just a platform for posting content; it’s a goldmine of data that, when harnessed..."/>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/The_role_of_AI_in_Next-Gen_Content_Marketing-A_startup's_guide" title="The Role of AI in Next-Gen Content Marketing: A Startup's Guide" text="Content marketing has evolved dramatically over the past decade. For startups, staying ahead in this ever-changing..."/>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/Building_global_brands_with_local_appeal-Strategies_for_startups" title="Building Global Brands with Local Appeal: Strategies for Startups" text="In today’s interconnected world, startups have a unique opportunity to expand beyond their local markets and..."/>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-3">
              <MyBlogs to="/blogs/Hypercontent’s_Playbook_for_viral_social_media_campaigns" title="Hypercontent’s Playbook for Viral Social Media Campaigns" text="In the digital age, where attention spans are shorter than ever, crafting a social media campaign that goes viral..."/>
            </div>
          </div>

        </div>
 

      </div>
    </>
  );
}

export default Blogs;
